var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuickClassbookWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 15.4167V4.16667C2.5 2.78596 3.61929 1.66667 5 1.66667H16.6667C17.1269 1.66667 17.5 2.03977 17.5 2.5V17.5C17.5 17.9603 17.1269 18.3333 16.6667 18.3333H5.41667C3.80583 18.3333 2.5 17.0275 2.5 15.4167ZM15.8333 16.6667V14.1667H5.41667C4.72631 14.1667 4.16667 14.7263 4.16667 15.4167C4.16667 16.107 4.72631 16.6667 5.41667 16.6667H15.8333ZM8.33333 3.33333H5C4.53977 3.33333 4.16667 3.70643 4.16667 4.16667V12.7807C4.54552 12.6007 4.96933 12.5 5.41667 12.5H15.8333V3.33333H14.1667V10L11.25 8.33333L8.33333 10V3.33333Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuickClassbookWhite);
export default __webpack_public_path__ + "static/media/quick-classbook-white.e0cf5643efd227d672dd3ca5e14744fc.svg";
export { ForwardRef as ReactComponent };